module.exports = __webpack_public_path__ + "img/cpzz14@2x.dd49369f.png";